import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const Login = () => import('@/views/login/index');
const Err404 = () => import('@/views/error/Err404');
const Layout = () => import('@/views/layout/layout');
const Home = () => import('@/views/home/index');
const ErrorLog = () => import('@/components/ErrorLog/index');
/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:'true'` will not show in the sidebar
 * redirect : if `redirect:noredirect` will no redirct in the levelbar
 * noDropdown : if `noDropdown:'true'` will has no submenu
 * meta : { role: ['admin'] }  will control the page role
 **/

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    hidden: 'true',
    noDropdown: 'false',
    meta: null,
    icon: '',
    redirect: null
  },
  {
    path: '/error-log',
    name: 'errorLog',
    component: ErrorLog,
    hidden: 'true',
    noDropdown: 'false',
    meta: null,
    icon: '',
    redirect: null
  },
  {
    path: '/404',
    name: 'error',
    component: Err404,
    hidden: 'true',
    noDropdown: 'false',
    meta: null,
    icon: '',
    redirect: null
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    noDropdown: 'true',
    hidden: 'false',
    meta: null,
    redirect: '/home',
    icon: "icon-home",
    children: [
      {
        path: 'home',
        component: Home,
        name: 'home',
        hidden: 'false',
        noDropdown: 'false',
        meta: null,
        icon: '',
        redirect: null
      },
    ]
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
});

export const asyncRouterMap = [];



// WEBPACK FOOTER //
// ./src/router/index.js